import { InjectionKey } from 'vue';
import { AxiosInstance } from 'axios';

export const ApiKey: InjectionKey<AxiosInstance> = Symbol('api');
